import script from "./CMD00510.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMD00510.vue?vue&type=script&setup=true&lang=ts"

import "./CMD00510.vue?vue&type=style&index=0&id=f3a94f8e&scoped=true&lang=css"
import "./CMD00510.vue?vue&type=style&index=1&id=f3a94f8e&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3a94f8e"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn,QField});
